import { useCurrentModule } from '../components';
import { PERSONALIZED_CONTENT_QUERY_OPTIONS, useIsPersonalizedContentEnabled, usePersonalizedParams } from './usePersonalizedParams';
export const usePersonalizedTitle = () => {
  const module = useCurrentModule();
  const isEnabled = useIsPersonalizedContentEnabled();
  const {
    params,
    enabled
  } = usePersonalizedParams();
  const {
    data,
    isLoading
  } = module.SDK.personalizedTitleApiClient.hooks.useGetPersonalizedTitle(params, enabled, PERSONALIZED_CONTENT_QUERY_OPTIONS);
  return {
    translation: isEnabled ? data == null ? void 0 : data.translation : undefined,
    isLoading: enabled && isLoading,
    isEnabled
  };
};
//# sourceMappingURL=usePersonalizedTitle.js.map